module.exports = "/_next/static/images/fee_visualization_mobile-f3cc4a7a91aafb571fd6834592c58a19.jpg";